import { cn } from "lib/utils";
import { TONE_DOT } from "shared/tones";
import { formatScore, scoreTone } from "./evaluationConfig";

/** Five-segment 1-5 meter; segments up to the rounded value are filled in the score's tone. */
export default function ScoreMeter({ value, className }: { value: number | null; className?: string }) {
  const scored = value != null && value > 0;
  const filled = scored ? Math.max(1, Math.round(value)) : 0;
  return (
    <div className={cn("flex gap-0.5", className)} role="img" aria-label={scored ? `${formatScore(value)} out of 5` : "Not scored"}>
      {[1, 2, 3, 4, 5].map((n) => (
        <span key={n} className={cn("h-1.5 flex-1 rounded-full", n <= filled ? TONE_DOT[scoreTone(value!)] : "bg-surface-muted border border-border")} />
      ))}
    </div>
  );
}
